import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import {isFunction} from "@firefly/fly-defter";
import {useAuthenticationPrincipal} from "./useAuthenticationPrincipal";
import {
    InsufficientAuthenticationException,
    isAccessDeniedException,
    isInsufficientAuthenticationException
} from "../core";

export type SecuredFallbackProps = {
    error: InsufficientAuthenticationException;
}
type FallbackType = React.ReactNode | ((props: SecuredFallbackProps) => React.ReactNode);

export interface SecuredBoundaryProps {
    fallback?: FallbackType;
    loading?: React.ReactNode;
    children: React.ReactNode;
}

// const INSUFFICIENT_AUTHENTICATION_EXCEPTION = ;
export default function SecuredBoundary(props: SecuredBoundaryProps): React.ReactElement {
    const {
        loading,
        fallback: _fallback,
        children
    } = props;

    const {
        principal,
        isPending,
        isAuthenticated
    } = useAuthenticationPrincipal();

    function fallback(props: SecuredFallbackProps): React.ReactNode {
        if (isFunction(_fallback)) {
            return _fallback(props);
        }
        return _fallback;
    }
    if (isPending) {
        return <React.Fragment>
            {loading}
        </React.Fragment>
    }
    if (!isAuthenticated) {
        return <React.Fragment>
            {fallback({
                error: new InsufficientAuthenticationException()
            })}
        </React.Fragment>
    }
    return <ErrorBoundary
        resetKeys={[principal]}
        fallbackRender={({error}) => {
            if (isInsufficientAuthenticationException(error)) {
                return fallback({
                    error,
                });
            }
            if (isAccessDeniedException(error)) {
                //若未认证
                if (!isAuthenticated) {
                    return fallback({
                        error: new InsufficientAuthenticationException()
                    });
                }

            }
            throw error;
        }}
    >
        {children}
    </ErrorBoundary>
}


